"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var totalTimeLoggedIn_styles_1 = require("./totalTimeLoggedIn.styles");
var luxon_1 = require("luxon");
var core_components_1 = require("@securityproducts/core-components");
var totalTimeLoggedIn_i18n_1 = require("./totalTimeLoggedIn.i18n");
function TotalTimeLoggedIn(props) {
    var strings = core_components_1.useLocalisation(totalTimeLoggedIn_i18n_1.totalTimeLogInTranslations, props.language);
    var infoText = React.createElement("div", { className: totalTimeLoggedIn_styles_1.tooltip }, strings.infoText);
    var totalTimeLoggedIn = {
        name: getTimeLoggedInTitle(props.limitedData, props.firstAvailableData, props.language),
        data: props.totalTimeLoggedIn,
        type: "line",
    };
    var lineStyles = [
        {
            stroke: "#64ae11",
            fill: "#ffffff",
        },
    ];
    return (React.createElement("div", { className: totalTimeLoggedIn_styles_1.chartWrapper },
        React.createElement(core_components_1.LineChart, { id: "totalTimeLoggedIn", heading: strings.totalTimeLoggedIn, data: [totalTimeLoggedIn], info: infoText, displayRange: props.display, lineStyles: lineStyles, metric: "time", language: props.language, timezone: props.timezone })));
}
exports.TotalTimeLoggedIn = TotalTimeLoggedIn;
TotalTimeLoggedIn.defaultProps = {
    totalTimeLoggedIn: [],
};
function getTimeLoggedInTitle(limitedData, firstAvailableData, language) {
    var strings = core_components_1.useLocalisation(totalTimeLoggedIn_i18n_1.totalTimeLogInTranslations, language);
    if (limitedData && firstAvailableData !== undefined) {
        var date = luxon_1.DateTime.fromJSDate(new Date(firstAvailableData))
            .setLocale(language)
            .toFormat("MMM dd, yyyy");
        return strings.totalTimeLoggedInSince + " " + date + ")";
    }
    else {
        return strings.totalTimeLoggedIn;
    }
}
